module.exports = __webpack_public_path__ + "img/menu-delivery.cd859ec9.svg";